module.exports = __webpack_public_path__ + "img/lexus.10181b96.png";